module.exports = __webpack_public_path__ + "static/media/prIcon.6a6bdc37.svg";